//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { cityList } from '@/model/javaApi/detail.js';
import BScroll from 'better-scroll'
export default {
    name: "city",
    data(){
        return {
            hostList:[],
            cityData:[],
            cityScroll:null,
            letterScroll:null
        }
    },
    created() {
        
        // new scroll  /并获取城市信息 
        this.$nextTick(() => {
            
            if (!this.cityScroll) {
                this.cityScroll = new BScroll(this.$refs.cityBox, {
                    click: true,
                    scrollY: true,
                });
                this.letterScroll = new BScroll(this.$refs.letter, {
                    click: true,
                    scrollY: true,
                });
                cityList().then(data=>{
                    this.hostList = [{cityId: "0000",cityName: "附近"}];
                    this.hostList = this.hostList.concat(data.hotCity);
                    this.hostList.push('');
                    this.cityData = data.cityData;
                })
            }else{
                this.cityScroll.refresh() 
            }
        })
        
    },
    mounted () {
        this.STATISTICS_CONFIG.insur_clinicsdetail_cityswitch_click()
        this.$emit('state', {
            titleCenter : '选择城市',
            titleLeft : '返回',
            state: 2,
        });
    },
    methods:{
        enable(){
            this.cityScroll.enable()
        },
        disable(){
            this.cityScroll.disable()
        },
        // 选择城市
        selectCity(item){
            this.STATISTICS_CONFIG.insur_clinicsdetail_city_select_click()

            console.log(item)
            this.$emit('state', {
                titleCenter : '当前城市门店',
                titleLeft : item.cityName,
                state: 1,
                city:{
                    code:item.cityId,
                    name:item.cityName
                }
            })
        },
        selectTab(index){
            this.cityScroll.enable()
             this.cityScroll.scrollToElement(
                this.$refs.cityRef.children[index+1],
                500
            );
        }
    }
}
